module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-serverview"
  }, [_c('div', {
    staticClass: "kiwi-serverview-inner"
  }, [_c('tabbed-view', {
    key: _vm.network.id
  }, [_c('tabbed-tab', {
    attrs: {
      "header": 'Messages',
      "focus": _vm.hasMessages
    }
  }, [_c('message-list', {
    attrs: {
      "buffer": _vm.serverBuffer,
      "messages": _vm.serverBuffer.getMessages()
    }
  })], 1), _vm._v(" "), _c('tabbed-tab', {
    attrs: {
      "header": _vm.$t('settings'),
      "focus": !_vm.hasMessages
    }
  }, [_c('network-settings', {
    attrs: {
      "network": _vm.network
    }
  })], 1), _vm._v(" "), (_vm.network.state === 'connected') ? _c('tabbed-tab', {
    attrs: {
      "header": _vm.$t('channels')
    }
  }, [_c('channel-list', {
    attrs: {
      "network": _vm.network
    }
  })], 1) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f71169da!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ServerView.vue
// module id = 510
// module chunks = 2